import { match } from 'ts-pattern'

import { DUE_DATE_PENDING_TEXT } from 'Invoices/constants'
import type { InvoiceDueDateCalculatedFrom } from 'Invoices/types'

export type FormatInvoiceDueDateOptions = {
  dueDate: string | undefined
  formatDate: (dueDate: string) => string
  /** Prepended to the date only - a pending due date reads "Pending", not "Due Pending". */
  prefix?: string
  /** Returned when there is neither a date nor a pending one to announce. */
  fallback?: string
}

/**
 * The due date to show outside the invoice editor. Due dates are calculated on
 * issue in ISSUE_DATE mode, so an unissued invoice has none to show yet.
 */
export const formatInvoiceDueDate = ({
  dueDate,
  calculatedFrom,
  formatDate,
  prefix = '',
  fallback
}: FormatInvoiceDueDateOptions & {
  calculatedFrom: InvoiceDueDateCalculatedFrom | null | undefined
}): string | undefined => {
  if (!dueDate) {
    return match(calculatedFrom)
      .with('ISSUE_DATE', () => DUE_DATE_PENDING_TEXT)
      .otherwise(() => fallback)
  }

  const formatted = formatDate(dueDate)

  return formatted ? `${prefix}${formatted}` : fallback
}
